<template>
  <header role="banner">
    <div class="container">
      <div class="meeting-banner">
        <h2>DeLand West to Dona Vista Transmission Line Project<p>To learn more, please visit the project website. <a :href="`/dwdv/${this.lang}`">Click here</a></p></h2>     
      </div>
      <div class="loghi">
        <!-- <a @click="back()">
          <img src="../assets/back-arrow.svg" width="16" height="16" alt="back">
        </a> -->
        <router-link :to="`/dwdv/${this.lang}`">
          <a href="#"><img src="../assets/logoduke.svg" class="logo" height="36" alt="DUKE Energy"></a>
        </router-link>
        
      </div>

    </div>
  </header>
</template>

<script>
  export default {
    name: 'my-header',
    props: {
      msg: String
    },
    computed: {
      lang () {
        return this.$store.state.lang
      },
      content () {
        return this.$store.state.data[this.proj][this.lang]
      },
      proj() {
        return this.$store.state.project
      }
    },
    methods: {
      back() {
        history.back()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  header {
    background: #fff;
    position: fixed;
    box-shadow: 0px 10px 15px 0px #0000001f;
    z-index: 10;
    top: 0;
    left: 0;
    border-top: 6px solid #005984;
    width: 100%;
    height: 91px;

    &>div {
      height: 100%;
      display: flex;
      align-items: stretch;
      justify-content: space-between;
    }

    .logo {
      width: auto;
      height: 42px;
      padding-left: 20px;
    }

    .loghi {
      padding: 10px 10px;
      display: flex;
      align-items: center;
      margin-left: 1rem;
    }

    .meeting-banner {
      padding: 0px 10px 0px 40px;
      background-color: #ffffff;
      border-radius: 40px 0px 0px 40px;
      display: flex;
      height: 100%;
      align-items: center;

      .text {
        margin: 0px 40px;
      }

      h2 {
        color: #005984;
        font-size: 1.8rem;
        font-weight: 600;
        margin: 0;
        line-height: 1.6rem;
      }

      p {
        font-size: 0.875rem;
        color: #005984;
        margin: 0;
        line-height: 1.6rem;
      }

      button,
      a.button {
        background-color: #fff;
        color: #EEB23A;
        border: 0px;
        border-radius: 50px;
        font-size: 1rem;
        padding: 10px 20px;
        font-weight: 600;
        text-decoration: none;
      }
    }
  }

  @media (max-width: 1024px) {
    header .meeting-banner {
      position: fixed;
      height: 100px;
      bottom: 0%;
      transform: translate3d(0px, 0px, 0px);
      border-radius: 0px;
      width: 100%;
      justify-content: center;
      align-items: center;
      padding: 0;
      display: none;
    }

    header .loghi {
      margin-left: 1rem;
    }

    .logo {
      width: auto;
      height: 24px;
      padding-left: 20px;
    }
  }

  @media (max-width: 768px) {
    header {
      height: 51px;

      .loghi {
        padding-left: 0rem;
        margin-left: 15px;
      }

      .logo {
        width: auto;
        height: 24px;
        padding-left: 10px;
      }

      .meeting-banner .text {
        margin: 0px 30px 0px 20px;
        display: none;
      }
    }
  }

  @media (max-width: 576px) {
    header {
      height: 51px;

      .loghi {
        margin-left: 15px;
        align-items: center;

        .logo {
          width: auto;
          height: 24px;
          padding-left: 10px;

        }
      }
    }
  }

  @media (max-width: 480px) {
    header {
      .meeting-banner {
        &.home {
          display: none;
        }

        padding: 0px 15px;
        justify-content: space-between;
        width: calc(100% - 30px);

        .text {

          margin: 0px;

          h2 {
            font-size: 1.25rem;
          }
        }

        button {
          padding: 10px 12px;
          ;
        }

        img {
          display: none;
        }
      }
    }
  }
</style>